export enum AccountsReceivablePermissionEnum {
    None = 0x00,
    CanView = 0x01 << 1,
    CanEditPaymentSchedule = 0x01 << 2,
}
